<style lang="scss">
@import '../../assets/scss/_variables';

.illustration-radio {
    user-select: none;

    input {
        opacity: 0;
        pointer-events: none;
        position: absolute;
            left: -10000px;
            z-index: 0;
    }

    label {
        width: 100%;
        margin: 0;
        padding: 34px 20px 5px 20px;
        cursor: pointer;

        background: none;
        transition:
            background $transition-illustration-radio,
            transform $transition-illustration-radio-active;
    }

        .image-wrapper {
            height: 54px;

            svg {
                max-width: 100%;
                height: 100%;
                fill: none;

                transition: all $transition-illustration-radio;
                stroke: $color-illustrations;

                .cls-1, .cls-2 {
                    stroke-width: 4.5px;
                }

                &.fa-icon {
                    width: 100%;
                }
            }
        }

        h4 {
            margin-top: 15px;
            letter-spacing: 2px;

            font-size: 18px;
            font-weight: normal;
            text-transform: uppercase;
            color: $color-text-3;

            transition: color $transition-illustration-radio;
        }

    input:checked + label,
    input:focus + label,
    label:hover {
        background: $color-background-1;

        svg {
            stroke: $color-accent-1;

            &.fa-icon {
                color: $color-accent-1;
            }
        }

        .title {
            color: $color-white;
        }
    }

    label:active {
        transform: scale(1.04);
    }

    @include media-smaller('lg') {
        width: (100% / 3);
    }

    @include media-smaller('md') {
        width: 50%;
    }
}
</style>

<template>
    <div class="illustration-radio">
        <input :id="idAttr" :name="name" :value="id" type="radio" v-model="handleModel">

        <label :for="idAttr">
            <div class="image-wrapper">
                <component v-if="data.image" :is="data.image"></component>
                <fa v-else-if="data.icon" :icon="data.icon" class="fa-icon"></fa>
            </div>
            <h4 v-if="data.title" class="title">{{ data.title }}</h4>
        </label>
    </div>
</template>

<script>
export default {
    props: ['id', 'name', 'data', 'value'],
    computed: {
        idAttr () {
            return 'form-' + this.name + '-' + this.id;
        },
        handleModel: {
            get () {
                return this.value;
            },
            set () {
                this.$emit('input', this.id);
            }
        }
    }
};
</script>
